import React from 'react';
import { FaAngleDown } from "react-icons/fa6";
import { FaAngleUp } from "react-icons/fa6";
import './thinking.css';

type Props = {
    children?: React.ReactNode;
};

type State = {
    show : boolean;
}

export class Thinking extends React.Component<Props, State> 
{
    constructor(props: Props) {
        super(props);

        this.state = {
            show : true
        }
    }

    toggleShow()
    {
        this.setState(prev => ({ show: !prev.show }));
    }

    render() {
        return (
            <div className="thinking">
                <div className="thinking-header" onClick={ () => this.toggleShow() }>
                    <span className="thinking-emoji">🤔</span>Thinking
                    <span className="thinking-button">
                    {this.state.show && (React.createElement(FaAngleUp as React.ComponentType))}
                    {!this.state.show && (React.createElement(FaAngleDown as React.ComponentType))}
                    </span>
                </div>
                { this.state.show && (
                    <div className="thinking-container">
                        { this.props.children }
                    </div>)
                }
            </div>
        );
    }
}

